const Globals = {
  mediaQuery: {
    mobile: '(max-width: 999px)',
  },
};

export default Globals;
